import { longClickDirective } from "vue-long-click";

const longClickInstance = longClickDirective({delay: 800, interval: 0});
Vue.directive('longclick', longClickInstance);


Vue.directive('clickaway', {
  bind: function (el, {value}) {
    if (typeof value !== 'function') {
      console.warn(`Expect a function, got ${value}`)
      return
    }

    document.addEventListener('click', e => el.contains(e.target) || value())
  }
})